import { ReactNode, createContext, useContext } from 'react';
import type { TenantFeatures } from '../models/tenantFeatures';

type AppContextValue = {
  clientLogo: ReactNode;
  dGLogo?: ReactNode;
  getRouteFromPath: (pathname: string) => { title: string; path: string } | undefined;
  tenantFeatures: TenantFeatures;
};

const AppContext = createContext<AppContextValue | null>(null);

export const AppContextProvider = AppContext.Provider;

export const useAppContext = () => {
  const ctx = useContext(AppContext);
  if (!ctx) {
    throw new Error('useAppContext must be used within AppContextProvider');
  }
  return ctx;
};
